const ROUTES = {
  LOGIN: '/login',
  LANGUAGE_SELECT: '/language',
  CONFIRM_USER_DATA: '/confirm',
  ACCOUNT: '/user',
  ASSESSMENT: '/assessment',
  EXAMINATION: '/examination',
  EXAMINATION_RECEIVE: '/receive-examination',
  PUBLIC_EXAMINATION: '/public-examination',
} as const;

export type RoutesKeys = keyof typeof ROUTES;
export type RoutesValues = (typeof ROUTES)[RoutesKeys];

export default ROUTES;
